import React from "react";

import { formatProjectCodeDisplay } from "../../utils/projectViews";

const CATEGORY_LABELS = {
  HEALTHCARE: "Healthcare",
  HOSPITAL: "Hospital",
  CLINIC: "Clinic",
  PHARMA: "Pharma",
  OTHER: "Project",
};

/**
 * Right-rail project visual for funded market cards (placeholder until image URL exists on projects).
 */
export default function FundedProjectVisual({ project, onViewOverview }) {
  const code = formatProjectCodeDisplay(project?.project_code) || "—";
  const name = (project?.name || "").trim();
  const category = String(project?.category || "OTHER").toUpperCase();
  const categoryLabel = CATEGORY_LABELS[category] || category;
  const hasOverview = Boolean(String(project?.overview_pdf_url || "").trim());

  return (
    <aside className="investor-funded-card__visual" aria-label="Project">
      <div className="investor-funded-card__visual-frame">
        <span className="investor-funded-card__visual-icon" aria-hidden>
          🏥
        </span>
        <span className="investor-funded-card__visual-code">{code}</span>
        {name ? <span className="investor-funded-card__visual-name">{name}</span> : null}
        <span className="investor-funded-card__visual-category">{categoryLabel}</span>
      </div>
      {hasOverview && onViewOverview ? (
        <button type="button" className="investor-funded-card__visual-btn compact-btn" onClick={onViewOverview}>
          View overview
        </button>
      ) : null}
    </aside>
  );
}
